import CurrencyCell from "../components/CurrencyCell";
import { cellStyle, currencyFormat } from "../helpers";

export const vanTargetColDef = () => {
  return [
    {
      field: "id",
      hide: true,
    },

    {
      headerClass: "primary",
      colId: "Country",
      field: "Country",
      width: 240,
      filter: true,
      enableRowGroup: true,
      // rowGroup: true,
      // cellRenderer: "agGroupCellRenderer",
    },
    {
      headerClass: "primary",
      colId: "Warehouse",
      field: "Warehouse",
      width: 240,
      filter: true,
      enableRowGroup: true,
      // rowGroup: true,
      // cellRenderer: "agGroupCellRenderer",
    },
    {
      headerName: "Channel",
      headerClass: "primary",
      colId: "Channel",
      field: "Channel",
      width: 240,
      filter: true,
      enableRowGroup: true,
      // rowGroup: true,
      // cellRenderer: "agGroupCellRenderer",
    },
    {
      headerName: "Van",
      headerClass: "primary",
      colId: "Van",
      field: "Van",
      width: 240,
      filter: true,
      enableRowGroup: true,
      // rowGroup: true,
      // cellRenderer: "agGroupCellRenderer",
    },
    {
      headerName: "Sales",
      headerClass: "primary",
      colId: "Sales",
      field: "Sales",
      width: 240,
      cellRenderer: CurrencyCell,
      type: "rightAligned",
      aggFunc: "sum",
      enableValue: true,
    },
    {
      headerName: "Correction",
      headerClass: "primary",
      colId: "Correction",
      field: "Correction",
      width: 200,
      editable: true,
      cellRenderer: CurrencyCell,
      type: "rightAligned",
      aggFunc: "sum",
      enableValue: true,
    },
    {
      field: "Date",
      hide: true,
    },
  ];
};
